"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var ContentShareConstants;
(function (ContentShareConstants) {
    ContentShareConstants["Modality"] = "#content";
})(ContentShareConstants || (ContentShareConstants = {}));
exports.default = ContentShareConstants;
